// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b57f2dc58a22e84ba47e6d4a0940e8b5a0a12f10.chunk.js";
};